export interface CompanionUiModel {
    id: number;
    profile: string;
    type: string;
    img: string
}

export class Companions {
    public static get(): Array<CompanionUiModel> {
        return [
            {
                id: 1,
                type: 'alone',
                img: 'assets/svg/companions/1.svg',
                profile: 'alone',
            },
            {
                id: 2,
                type: 'friends',
                img: 'assets/svg/companions/2.svg',
                profile: 'friends',
            },
            {
                id: 3,
                type: 'adults',
                img: 'assets/svg/companions/3.svg',
                profile: 'adults',
            },
        ];
    }

    public static valueOf(profile: string): CompanionUiModel {
        return this.get().find(it => it.profile === profile);
    }
}
